<template>
    <div :class="[ toastShow? 'on': '' ,'sqToast']"><!-- css已設display:none; -->
        <div class="sq-wrapper">
            <div class="content">
                <i :class="'icon-export'"></i>
                <div class="txt">{{toastContent}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'v3favoritesToast',
    props: {
        show: Boolean,
        content: String,
        full: Boolean,
        showTime: Number,
    },
    data(){
        return {
            toastShow: this.show,
            toastContent: this.content,
            toastFull: this.full,
            toastShowTime: this.showTime,
            setTimeObj: null
        }
    },

    mounted(){

    },
    watch:{
        show:{
            handler(val){
                let vobj = this
                vobj.toastShow = vobj.show
                vobj.toastContent = vobj.content
                vobj.toastFull = vobj.full
                vobj.toastShowTime = vobj.showTime
                if(val){
                    setTimeout(()=>{
                        vobj.toastShow = false
                        this.$emit('close')
                    },vobj.toastShowTime)
                }
            }
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/common/toast/v3favoritesToast.vue